let isInitialized = false;

function init() {
  if (!!isInitialized) return;
  console.log('initializing');
  try {
    changeTitleAndSubtitle();
    loadTagsFromDOM();
    insertTextAroundHeader();
    insertReasonsAfterActionBoxTop();
    insertStepsLabels();
    // updateFreeShippingStep();
    switchPositionBuyOptions();
    setTimeout(insertInformationsLabels, 1000);
    isInitialized = true;
    console.log('initialized');
  } catch (error) {
    console.error(error);
  }
}

document.addEventListener("bundle-builder:ready", function () {
  init();
});

document.addEventListener("DOMContentLoaded", function () {
  init();
  setTimeout(init, 1000);
  setTimeout(init, 2000);
  setTimeout(init, 3000);
  setTimeout(init, 4000);
  setTimeout(init, 5000);
  setTimeout(init, 6000);
  setTimeout(init, 7000);
});

function getStorageText(key) {
  const storage = document.querySelector('[data-bundle-builder-storage]');
  if (!storage) throw new Error('Storage not found');
  const span = storage.querySelector(`[data-bundle-builder-storage-${key}]`);
  return span ? span.textContent : '';
}

function loadTagsFromDOM() {
  try {
    const tags = document.getElementById('bundle-builder-products-tags');
    if (!tags) {
      throw new Error('JSON script tag with ID "bundle-builder-products-tags" not found.');
    }
    // Parse the text content of the script tag into a JavaScript object
    const productTags = JSON.parse(tags.textContent);
    console.log('Product tags loaded successfully from DOM.');
    return productTags;
  } catch (error) {
    console.error('Error loading or parsing product tags from DOM:', error);
    return null;
  }
}

function changeTitleAndSubtitle() {
  const title = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__step-header-title');
  const subtitle = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__step-header-description');
  if (title) {
    title.textContent = getStorageText('main-title-label');
  }
  if (subtitle) {
    subtitle.textContent = getStorageText('main-subtitle-label');
  }
}

function getElementaByVariantId(variantId) {
  console.log('variantId', variantId);
  return document.querySelector(`[data-rebuy-id='218767'] [href *= '?variant=${variantId}']`);
}

function insertInformationsLabels() {
  const tagsFromJson = loadTagsFromDOM();
  if (!tagsFromJson) {
    return;
  }

  const tagsArray = tagsFromJson.tags;

  tagsArray.forEach(tagElem => {
    const link = getElementaByVariantId(tagElem.variantId);
    if (!!link) {
      link.style.position = 'relative';
      const labelsContainer = document.createElement('div');
      labelsContainer.className = 'naali-img-product-labels';

      tagElem.tags.forEach((tag) => {
        const tagSpan = document.createElement('span');
        tagSpan.className = 'naali-img-product-label';
        tagSpan.textContent = tag;
        labelsContainer.appendChild(tagSpan);
      });

      link.appendChild(labelsContainer);
    }
  })
}


function updateFreeShippingStep() {
  const icon = `
  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scale(1.8);">
    <path d="M4.90266 12.405C4.27476 12.405 3.7408 12.1852 3.30078 11.7456C2.86062 11.3058 2.64054 10.7719 2.64054 10.1439H1.44997C1.27525 10.1439 1.12876 10.0848 1.0105 9.96651C0.892375 9.84825 0.833313 9.70176 0.833313 9.52703C0.833313 9.35218 0.892375 9.20575 1.0105 9.08777C1.12876 8.96964 1.27525 8.91058 1.44997 8.91058H3.06439C3.25514 8.59745 3.51209 8.34791 3.83522 8.16195C4.15821 7.97586 4.51368 7.88281 4.90163 7.88281C5.28958 7.88281 5.64512 7.97586 5.96825 8.16195C6.29124 8.34791 6.54818 8.59745 6.73907 8.91058H10.3535L12.1198 1.3051H3.85803C3.68331 1.3051 3.53689 1.24597 3.41877 1.12771C3.3005 1.00944 3.24137 0.862953 3.24137 0.688232C3.24137 0.513375 3.3005 0.366952 3.41877 0.248964C3.53689 0.13084 3.68331 0.0717773 3.85803 0.0717773H12.7285C12.9709 0.0717773 13.1665 0.165372 13.3151 0.352563C13.4637 0.539617 13.509 0.750173 13.451 0.98423L12.9482 3.15508H14.2621C14.4976 3.15508 14.7205 3.2077 14.931 3.31295C15.1416 3.41833 15.315 3.56386 15.4513 3.74954L16.9613 5.75307C17.0962 5.92903 17.1829 6.1169 17.2213 6.3167C17.2598 6.51636 17.2612 6.72219 17.2254 6.93418L16.702 9.54944C16.6661 9.72539 16.5793 9.86846 16.4414 9.97864C16.3035 10.0888 16.1469 10.1439 15.9715 10.1439H15.2899C15.2899 10.7711 15.0702 11.3047 14.6307 11.7448C14.1912 12.1849 13.6576 12.405 13.0298 12.405C12.4021 12.405 11.8681 12.1852 11.428 11.7456C10.9879 11.3058 10.7679 10.7719 10.7679 10.1439H7.16272C7.16272 10.7711 6.94298 11.3047 6.50351 11.7448C6.06403 12.1849 5.53042 12.405 4.90266 12.405ZM12.0185 7.16337H15.9146L16.0284 6.58145L14.3887 4.3884H12.6652L12.0185 7.16337ZM10.4738 8.42671L10.594 7.89021C10.6741 7.53255 10.7757 7.09472 10.8991 6.57672C10.9507 6.36172 10.9984 6.16301 11.0421 5.98062C11.0858 5.79822 11.1214 5.63433 11.1488 5.48893L11.2691 4.95244C11.3492 4.59478 11.451 4.15695 11.5743 3.63895C11.6975 3.12096 11.7992 2.68313 11.8793 2.32547L11.9996 1.78897L12.1198 1.3051L10.3535 8.91058L10.4738 8.42671ZM0.600832 7.19339C0.428304 7.19339 0.283731 7.13425 0.167114 7.01599C0.0504962 6.89773 -0.0078125 6.75124 -0.0078125 6.57652C-0.0078125 6.40166 0.0512499 6.25524 0.169375 6.13725C0.287499 6.01913 0.433922 5.96006 0.608643 5.96006H3.47858C3.6533 5.96006 3.79972 6.0192 3.91785 6.13746C4.03611 6.25572 4.09524 6.40228 4.09524 6.57714C4.09524 6.75186 4.03611 6.89828 3.91785 7.0164C3.79972 7.13439 3.6533 7.19339 3.47858 7.19339H0.600832ZM2.24526 4.25561C2.07054 4.25561 1.92412 4.19648 1.80599 4.07822C1.68773 3.95996 1.6286 3.81347 1.6286 3.63875C1.6286 3.46389 1.68773 3.3174 1.80599 3.19928C1.92412 3.08129 2.07054 3.02229 2.24526 3.02229H5.94522C6.11994 3.02229 6.26637 3.08142 6.38449 3.19969C6.50275 3.31795 6.56188 3.46444 6.56188 3.63916C6.56188 3.81402 6.50275 3.96044 6.38449 4.07843C6.26637 4.19655 6.11994 4.25561 5.94522 4.25561H2.24526ZM4.90163 11.1717C5.18735 11.1717 5.43004 11.0718 5.6297 10.872C5.8295 10.6723 5.9294 10.4296 5.9294 10.1439C5.9294 9.85818 5.8295 9.61549 5.6297 9.41583C5.43004 9.21603 5.18735 9.11613 4.90163 9.11613C4.61591 9.11613 4.37322 9.21603 4.17356 9.41583C3.97376 9.61549 3.87386 9.85818 3.87386 10.1439C3.87386 10.4296 3.97376 10.6723 4.17356 10.872C4.37322 11.0718 4.61591 11.1717 4.90163 11.1717ZM13.029 11.1717C13.3146 11.1717 13.5573 11.0718 13.7571 10.872C13.9569 10.6723 14.0568 10.4296 14.0568 10.1439C14.0568 9.85818 13.9569 9.61549 13.7571 9.41583C13.5573 9.21603 13.3146 9.11613 13.029 9.11613C12.7433 9.11613 12.5005 9.21603 12.3007 9.41583C12.1009 9.61549 12.001 9.85818 12.001 10.1439C12.001 10.4296 12.1009 10.6723 12.3007 10.872C12.5005 11.0718 12.7433 11.1717 13.029 11.1717Z" fill="#252525"></path>
  </svg>
  `

  const step = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__progress-step--1 > .rebuy-bundle-builder__progress-step-icon');
  if (!step) throw new Error('Step not found');

  step.innerHTML = `${icon}`
}

function insertStepsLabels() {
  const span = document.querySelectorAll('[data-rebuy-id="218767"] .rebuy-bundle-builder__progress-step-label');

  if (span.length > 0) {
    span.forEach((parent, idx) => {
      const priceElem = document.createElement('span');
      priceElem.className = 'rebuy-bundle-builder__progress-step-price';
      priceElem.textContent = getStorageText(`step-label-${idx + 1}`) + '€';
      parent.appendChild(priceElem);
    });
  } else {
    throw new Error('Span not found')
  }
}

// Fonction pour insérer du texte avant et après la div cible
function insertTextAroundHeader() {
  const targetDiv = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__group-container-header--left');

  if (targetDiv) {
    const existingDot = document.querySelector('[data-rebuy-id="218767"] .naali-green-dot-text-container');
    if (!existingDot) {

      // Créer l'élément de texte à insérer avant
      const textBefore = document.createElement('div');
      textBefore.className = 'naali-green-dot-text-container';

      // Créer la pastille verte scintillante
      const greenDot = document.createElement('span');
      greenDot.className = 'naali-green-dot-blink';

      // Ajout du style d'animation dans le head si pas déjà présent
      if (!document.getElementById('naali-green-dot-blink-style')) {
        const style = document.createElement('style');
        style.id = 'naali-green-dot-blink-style';
        style.textContent = `@keyframes naali-blink { 0% { opacity: 1; box-shadow: 0 0 8px 2px #6f6; } 100% { opacity: 0.5; box-shadow: 0 0 16px 4px #6f6; } }`;
        document.head.appendChild(style);
      }
      // Ajoute la pastille et le texte dans textBefore
      textBefore.appendChild(greenDot);
      const textNode = document.createElement('span');
      textNode.textContent = getStorageText('buy-count-label');
      textNode.className = 'naali-green-dot-label';
      textBefore.appendChild(textNode);
      // Insérer le texte avant
      targetDiv.parentNode.insertBefore(textBefore, targetDiv);
    }

    const existingPreviewSubtitle = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder_preview-header-subtitle');
    if (!existingPreviewSubtitle) {
      // Créer l'élément de texte à insérer après
      const textAfter = document.createElement('div');
      textAfter.textContent = getStorageText('preview-subtitle-label');
      textAfter.className = 'rebuy-bundle-builder_preview-header-subtitle';
      // Insérer le texte après
      targetDiv.parentNode.insertBefore(textAfter, targetDiv.nextSibling);
    }
  } else {
    throw new Error('Target div not found')
  }
}

function switchPositionBuyOptions() {
  const parent = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__subscription-options');

  if (!!parent) {
    const first = parent.children[0];
    const second = parent.children[1];

    if (!!first && !!second) {
      parent.insertBefore(second, first);
      // Cherche le span dans l'arborescence div > div > label > span
      const targetSpan = first.querySelector('div > label > span');
      if (targetSpan) {
        targetSpan.innerHTML = `
            ${getStorageText('subscribe-label')}
            <span class="rebuy-bundle-builder_buy-option-renew">
              ${getStorageText('subscribe-highlight-label')}
            </span>`;
      } else {
        targetSpan.innerHTML = "S'abonner & Économisez 25% *";
      }
      // Force le span parent à ne pas couper le texte
      targetSpan.classList.add("rebuy-bundle-builder_buy-option-renew-parent");
    }

    const targetSpanPrice = first.querySelector('div > div > span');
    if (targetSpanPrice) {
      targetSpanPrice.classList.add("rebuy-bundle-builder_price-buy-options");
    }
  }
}

function insertReasonsAfterActionBoxTop() {
  // Sélectionne l'élément cible
  const actionBoxTop = document.querySelector('[data-rebuy-id="218767"] .rebuy-bundle-builder__subscription-options');
  if (!actionBoxTop) throw new Error('Action box top not found');

  const icon = `
  <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.23044 6.01324L9.53303 0.710652C9.65817 0.585517 9.80416 0.522949 9.97101 0.522949C10.1379 0.522949 10.2838 0.585517 10.409 0.710652C10.5341 0.835786 10.5967 0.984384 10.5967 1.15644C10.5967 1.32851 10.5341 1.4771 10.409 1.60224L4.66841 7.35844C4.54328 7.48358 4.39729 7.54615 4.23044 7.54615C4.0636 7.54615 3.9176 7.48358 3.79247 7.35844L1.10207 4.66804C0.976934 4.54291 0.916974 4.39431 0.922188 4.22225C0.927402 4.05019 0.992576 3.90159 1.11771 3.77646C1.24285 3.65132 1.39144 3.58875 1.5635 3.58875C1.73556 3.58875 1.88416 3.65132 2.0093 3.77646L4.23044 6.01324Z" fill="black"/>
  </svg>`

  // Crée un conteneur pour le HTML
  const reasonsDiv = document.createElement('div');
  reasonsDiv.className = 'naali-reasons-container';
  reasonsDiv.innerHTML = `
      <div>
        <p>
          ${getStorageText('annotation-label')}
        </p>
        <ul>
          <li>
            ${icon}
            ${getStorageText('reason-1-label')}
          </li>
          <li>
            ${icon}
            ${getStorageText('reason-2-label')}            
          </li>
          <li>
            ${icon}
            ${getStorageText('reason-3-label')}           
          </li>
          <li>
            ${icon}
            ${getStorageText('reason-4-label')}            
          </li>
        </ul>
      </div>
    `;


  // Insère juste après l'élément cible
  actionBoxTop.parentNode.insertBefore(reasonsDiv, actionBoxTop.nextSibling);
}
